import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ShipService } from '../../services/ship.service';
import { Ship } from '../../Ship';
import { EntitlementService } from '../../services/entitlement.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ship-profiles',
  templateUrl: './ship-profiles.component.html',
  styleUrls: ['./ship-profiles.component.css']
})
export class ShipProfilesComponent implements OnInit {
  @ViewChild('searchButton', { static: false }) searchButton: ElementRef;
  @ViewChild('shipNameSearchButton', { static: false })
  shipNameSearchButton: ElementRef;
  ships: string[];
  results: Ship[];
  pendingShips: Ship[];
  searchResults: Ship[];
  whichView = 'none';
  whichPendingShipView = 'none';
  selectedLocation = '';
  processing = false;
  newSearchTerm = '';
  registarMode = false;
  fleetAlert = '';
  alertShips: Map<string, object> = new Map<string, object>();

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private router: Router
  ) {}

  ngOnInit() {
    this.searchResults = this.shipService.retieveAllShipProfileResults();
    this.processing = true;
    this.whichView = 'searchResults';
    this.shipService.getShipProfiles().subscribe(
      (data: Ship[]) => {
        const someships = data;
        this.ships = someships.map((ship) => {
          return ship.shipName;
        });
      },
      () => {
        console.log('There was an error fetching ship information.');
      },
      () => {
        this.processing = false;
        this.newSearchTerm = this.shipService.getPendingSearch();
        if (this.newSearchTerm !== null) {
          this.handleSearch(this.newSearchTerm);
        }
      }
    );
    this.shipService.checkPermissionedUsers().subscribe(
      (data: Map<string, object>) => {
        this.alertShips = data;
        const mapSize: number = this.alertShips.size;
        if (mapSize === 1) {
          this.fleetAlert = '1 location does not have two active permissioned users.'
        }
        else {
          this.fleetAlert = mapSize + ' locations do not have two active permissioned users.'
        }
      },
      () => {
        console.log('There was an error fetching fleet health information.');
      },
      () => {
      }
    );
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  onSearchClick() {
    const searchString =
      this.selectedLocation.trim().length > 0
        ? this.selectedLocation
        : (<HTMLInputElement>document.getElementById('location')).value;
    if (searchString.trim().length > 0) {
      this.processing = true;
      this.handleSearch(searchString);
    } else {
      this.searchButton.nativeElement.blur();
    }
  }

  handleSearch(searchTerm) {
    this.shipService.searchShipProfiles(searchTerm).subscribe(
      (data) => {
        this.results = data;
      },
      (error) => {
        console.log('There was a problem fetching merchant data');
        console.log(error.error);
      },
      () => {
        this.processing = false;
        this.whichView = 'results';

        if (this.results.length === 0) {
          this.whichView = 'noResults';
        }
      }
    );
  }

  onSearchEnter(event) {
    this.searchButton.nativeElement.focus();
  }

  onRegisterClick() {
    this.registarMode = true;
  }

  selectLocation(location: any) {
    this.selectedLocation = location.value;
    this.searchButton.nativeElement.focus();
    this.onSearchClick();
  }

  shipSelected(shipData: Ship) {
    this.shipService.storeShipProfile(shipData);
    this.shipService.storeShipProfileResult(shipData);
    this.router.navigate(['/shipProfiles/roundtrips']);
  }
}
